// extracted by mini-css-extract-plugin
export default {"block":"FubConnectionProfileIcon_block__PD2iO"};